import { storage, storageRef } from '../../firebase/firebaseSetup';

import {
    deleteObject,
    ref,
    StorageReference,
    list,
    ListResult,
    uploadBytes,
    UploadResult,
    getDownloadURL,
    getMetadata,
    SettableMetadata
} from 'firebase/storage';

import ErrorInterface from '../interfaces/errorInterface';
import { OwnerFilesInterface } from '../ownership';

export default class ImageService {
    collectionId: string;
    constructor(collectionId: string) {
        this.collectionId = collectionId;
    }

    private getFileInfo = async (
        reference: StorageReference
    ): Promise<OwnerFilesInterface | ErrorInterface> => {
        try {
            const promises = await Promise.all([
                reference,
                getDownloadURL(reference),
                getMetadata(reference)
            ]);
            return {
                id: reference.toString(),
                ref: promises[0],
                url: promises[1],
                metadata: promises[2]
            } as OwnerFilesInterface;
        } catch (e: any) {
            console.error(e);
            return {
                error: true,
                errorMsg: e.message
            } as ErrorInterface;
        }
    };

    getFiles = async (
        path: string
    ): Promise<OwnerFilesInterface[] | ErrorInterface> => {
        const listFiles = (await list(
            ref(storageRef.root, path)
        )) as ListResult;

        const references = listFiles.items as StorageReference[];
        const promises = references.map((item: StorageReference) =>
            this.getFileInfo(item)
        );
        let files = (await Promise.all(promises)) as any;
        return files as OwnerFilesInterface[];
    };

    uploadFile = async (
        file: File,
        item: any,
        metadata?: SettableMetadata
    ): Promise<string | ErrorInterface> => {
        // console.log(
        //     `${this.collectionId}/${item.id}/${Date.now()}_${file.name}`
        // );
        try {
            const reference = ref(
                storageRef.root,
                `${this.collectionId}/${item.id}/${Date.now()}_${file.name}`
            );
            const blob = (await uploadBytes(
                reference,
                file,
                metadata
            )) as UploadResult;

            const url = (await getDownloadURL(blob.ref)) as string;
            return url;
        } catch (e: any) {
            console.error(e);
            return {
                error: true,
                errorMsg: e.message
            } as ErrorInterface;
        }
    };

    uploadFiles = async (
        files: File[],
        item: any,
        metadata?: SettableMetadata
    ): Promise<string[]> => {
        const urls = await Promise.all(
            files.map((file) => this.uploadFile(file, item, metadata))
        );
        return urls as string[];
    };

    deleteFile = async (imageURL: string): Promise<void | ErrorInterface> => {
        try {
            const reference = ref(storage, imageURL);
            await deleteObject(reference);
            return;
        } catch (e: any) {
            console.error(e);
            return {
                error: true,
                errorMsg: e.message
            } as ErrorInterface;
        }
    };

    deleteFiles = async (itemId: string): Promise<void> => {
        const path = `${this.collectionId}/${itemId}`;
        const files = (await this.getFiles(path)) as OwnerFilesInterface[];
        await Promise.all((files || []).map((f) => this.deleteFile(f.url)));
        return;
    };
}
